(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8515],{

/***/ 29387:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute")}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),

/***/ 29099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ PageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atomic/PageContainer/PageContainer.tsx

var PageContainer = function(param) {
    var children = param.children, _containerClass = param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        className: "container container--body ".concat(containerClass),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/atomic/PageContainer/index.ts



/***/ }),

/***/ 52488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/Breadcrumbs/breadcrumbs.module.scss
var breadcrumbs_module = __webpack_require__(11783);
var breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_module);
;// CONCATENATED MODULE: ./components/styleguide/Breadcrumbs/Breadcrumbs.tsx







var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Breadcrumbs = function(param) {
    var crumbs = param.crumbs, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "".concat((breadcrumbs_module_default()).main, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            className: (breadcrumbs_module_default()).crumbs,
            children: [
                crumbs.length > 1 && crumbs.slice(0, crumbs.length - 1).map(function(crumb) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (breadcrumbs_module_default()).crumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                            icon: crumb.icon,
                            href: crumb.slug,
                            hierarchy: Button/* ButtonHierarchy.Borderless */.B.Borderless,
                            size: system/* Size.Small */.$u.Small,
                            children: crumb.label
                        })
                    }, crumb.slug);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "".concat((breadcrumbs_module_default()).crumb, " ").concat((breadcrumbs_module_default()).current),
                    "aria-current": "page",
                    children: [
                        crumbs[crumbs.length - 1].icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            name: crumbs[crumbs.length - 1].icon,
                            size: system/* Size.Small */.$u.Small
                        }),
                        crumbs[crumbs.length - 1].label
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Breadcrumbs/index.ts



/***/ }),

/***/ 65299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ ChatWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/ChatWidget.tsx



var ChatWidget = function() {
    if (!(0,system/* isProd */.BB)() || !"0e82ae7a-23e7-4571-a768-93f6cea963b2") {
        return false;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "ze-snippet",
        strategy: "lazyOnload",
        src: "https://static.zdassets.com/ekr/snippet.js?key=".concat("0e82ae7a-23e7-4571-a768-93f6cea963b2")
    });
};

;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/index.ts



/***/ }),

/***/ 43724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ChipGroup; }
});

// UNUSED EXPORTS: Chip

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
;// CONCATENATED MODULE: ./components/styleguide/Chip/Chip.tsx







var Chip = function(_param) {
    var chipId = _param.chipId, label = _param.label, action = _param.action, chipType = _param.chipType, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "chipId",
        "label",
        "action",
        "chipType"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        label: label,
        size: system/* Size.Medium */.$u.Medium,
        hierarchy: chipType,
        onClick: function(e) {
            e.preventDefault();
            if (action) {
                action({
                    chipId: chipId,
                    label: label
                });
            }
        }
    }));
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./components/styleguide/Chip/chip.module.scss
var chip_module = __webpack_require__(37404);
var chip_module_default = /*#__PURE__*/__webpack_require__.n(chip_module);
;// CONCATENATED MODULE: ./components/styleguide/Chip/ChipGroup.tsx











var ChipGroup = function(param) {
    var chips = param.chips, _theme = param.theme, theme = _theme === void 0 ? system/* Theme.light */.Q2.light : _theme, className = param.className, onChipChange = param.onChipChange, active = param.active, _doesScrollIntoViewOnLoad = param.doesScrollIntoViewOnLoad, doesScrollIntoViewOnLoad = _doesScrollIntoViewOnLoad === void 0 ? false : _doesScrollIntoViewOnLoad, _allowMultiple = param.allowMultiple, allowMultiple = _allowMultiple === void 0 ? false : _allowMultiple, _hasScroll = param.hasScroll, hasScroll = _hasScroll === void 0 ? true : _hasScroll;
    var ref = (0,react.useState)(active || [
        chips[0].chipId
    ]), selected = ref[0], setSelected = ref[1];
    var groupRef = (0,react.useRef)(null);
    var chipType = allowMultiple ? Button/* ButtonHierarchy.ChipFilter */.B.ChipFilter : Button/* ButtonHierarchy.ChipChoice */.B.ChipChoice;
    var isMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: 991
    });
    var scrollSelectedChipIntoView = function() {
        var ref;
        var selectedIndex = chips.findIndex(function(chip) {
            return selected.includes(chip.chipId);
        });
        var selectedChip = (ref = groupRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("button:nth-of-type(".concat(selectedIndex + 1, ")"));
        selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.scrollIntoView(false);
    };
    (0,react.useEffect)(function() {
        if (doesScrollIntoViewOnLoad && !isMobile) {
            scrollSelectedChipIntoView();
        }
    // eslint-disable-next-line
    }, [
        doesScrollIntoViewOnLoad
    ]);
    (0,react.useEffect)(function() {
        if (!selected) {
            setSelected([
                chips[0].chipId
            ]);
        }
    }, [
        chips,
        selected
    ]);
    var handleOnChipChange = function(chipId) {
        if (allowMultiple) {
            setSelected(function(prev) {
                var selectedCopy = (0,_to_consumable_array/* default */.Z)(prev);
                if (selectedCopy.includes(chipId)) {
                    return selectedCopy.filter(function(item) {
                        return item !== chipId;
                    });
                } else {
                    return [
                        chipId
                    ].concat((0,_to_consumable_array/* default */.Z)(selectedCopy));
                }
            });
        } else {
            setSelected([
                chipId
            ]);
        }
        if (onChipChange) {
            onChipChange(chipId);
        }
    };
    (0,react.useEffect)(function() {
        if (active) {
            setSelected(active);
        }
    }, [
        active
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((chip_module_default()).group, " ").concat(className ? className : ""),
        "data-has-scroll": hasScroll,
        ref: groupRef,
        children: [
            allowMultiple && active && active.map(function(activeChip) {
                var selectedChip = chips.filter(function(chip) {
                    return chip.chipId === activeChip;
                })[0];
                return /*#__PURE__*/ (0,react.createElement)(Chip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedChip), {
                    chipType: chipType,
                    key: activeChip,
                    isSelected: true,
                    action: function() {
                        return handleOnChipChange(activeChip);
                    },
                    theme: theme
                }));
            }),
            allowMultiple && active && chips.filter(function(chip) {
                return active.length === 0 || !active.includes(chip.chipId);
            }).map(function(chip) {
                return /*#__PURE__*/ (0,react.createElement)(Chip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chip), {
                    chipType: chipType,
                    key: chip.chipId,
                    isSelected: false,
                    action: function() {
                        return handleOnChipChange(chip.chipId);
                    },
                    theme: theme
                }));
            }),
            !allowMultiple && chips.map(function(chip) {
                return /*#__PURE__*/ (0,react.createElement)(Chip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chip), {
                    chipType: chipType,
                    key: chip.chipId,
                    isSelected: selected.includes(chip.chipId),
                    action: function() {
                        return handleOnChipChange(chip.chipId);
                    },
                    theme: theme
                }));
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Chip/index.ts




/***/ }),

/***/ 38510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* reexport */ Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/styleguide/Dropdown/dropdown.module.scss
var dropdown_module = __webpack_require__(76625);
var dropdown_module_default = /*#__PURE__*/__webpack_require__.n(dropdown_module);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Dropdown/Dropdown.tsx






var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Dropdown = function(param) {
    var id = param.id, hint = param.hint, label = param.label, disabled = param.disabled, options = param.options, emptyOptionLabel = param.emptyOptionLabel, handleOnChange = param.handleOnChange, _isCompact = param.isCompact, isCompact = _isCompact === void 0 ? false : _isCompact, _labelPrefix = param.labelPrefix, labelPrefix = _labelPrefix === void 0 ? "" : _labelPrefix, className = param.className, parentStyles = param.parentStyles, required = param.required;
    var ref = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)({
        name: id,
        value: emptyOptionLabel || options.length === 0 ? "empty-option" : undefined
    }), 3), field = ref[0], meta = ref[1], setValue = ref[2].setValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((dropdown_module_default()).main, " ").concat(isCompact ? (dropdown_module_default()).compact : "", " ").concat(className ? className : "", " ").concat(parentStyles ? parentStyles.main : ""),
        "data-error": !!meta.error,
        "data-disabled": disabled,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: id,
                className: (dropdown_module_default()).label,
                children: [
                    label,
                    required && "*"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((dropdown_module_default()).select, " ").concat(parentStyles ? parentStyles.select : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                        name: field.name,
                        onChange: function(e) {
                            if (e) {
                                setValue(e.target.value);
                                if (handleOnChange) {
                                    handleOnChange(e.target.value);
                                }
                            }
                        },
                        disabled: disabled,
                        className: "".concat((dropdown_module_default()).control, " ").concat(field.value === "empty-option" || field.value === "" ? (dropdown_module_default())["default-selected"] : ""),
                        value: field.value,
                        children: [
                            (emptyOptionLabel || options.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "empty-option",
                                className: (dropdown_module_default()).placeholder,
                                children: emptyOptionLabel ? emptyOptionLabel : "Select an option"
                            }),
                            options.map(function(option) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                    value: option.value,
                                    children: [
                                        labelPrefix,
                                        option.label ? option.label : option.value
                                    ]
                                }, option.value);
                            })
                        ]
                    }),
                    !isCompact && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        customClass: "".concat((dropdown_module_default()).icon, "  ").concat(parentStyles ? parentStyles.icon : ""),
                        name: "ChevronDown",
                        size: system/* Size.Small */.$u.Small
                    })
                ]
            }),
            (hint || meta.error) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (dropdown_module_default()).foot,
                "data-error": !!meta.error,
                children: meta.error ? meta.error : hint
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Dropdown/index.ts



/***/ }),

/***/ 85154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* reexport */ SearchFormCTA; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/reducers/search.js + 1 modules
var reducers_search = __webpack_require__(29109);
// EXTERNAL MODULE: ./components/views/SearchForm/search-form.module.scss
var search_form_module = __webpack_require__(87053);
var search_form_module_default = /*#__PURE__*/__webpack_require__.n(search_form_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Chip/index.ts + 2 modules
var Chip = __webpack_require__(43724);
// EXTERNAL MODULE: ./components/styleguide/Dropdown/index.ts + 1 modules
var Dropdown = __webpack_require__(38510);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./lib/hooks/useExperiment.ts
var useExperiment = __webpack_require__(46389);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/views/SearchForm/SearchForm.tsx

















var MediaQuery = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 1852, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1852)
            ];
        }
    },
    ssr: false
});
var savedSearchReferences = [
    {
        ref: "4d56b4a8c34e632f514f4fa957ad65d8",
        label: "Under \xa3250/pm"
    },
    {
        ref: "b960d43d5d3c027d4926af1a646c536f",
        label: "Family cars"
    },
    {
        ref: "ddacda9c0bcc3b550c12c696e7049b18",
        label: "Electric cars"
    }, 
];
var SearchForm = function(param) {
    var initialVehicleType = param.initialVehicleType, _hasRedirectToLandingPage = param.hasRedirectToLandingPage, hasRedirectToLandingPage = _hasRedirectToLandingPage === void 0 ? false : _hasRedirectToLandingPage, _hideToggle = param.hideToggle, hideToggle = _hideToggle === void 0 ? false : _hideToggle;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useExperiment/* useExperiment */.a)(), 1), experimentGroup = ref[0];
    var handleChangeVehicleType = function(newType) {
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "homepage-search-filter",
            action: newType.toString(),
            experimentGroup: experimentGroup
        });
        if (hasRedirectToLandingPage) {
            router.replace("/".concat(newType === constants/* FILTER_VEHICLE_TYPES_CARS */.DC ? "" : "van-leasing"));
        }
    };
    var onCarSearchSubmit = function(values) {
        if (typeof window.ttq !== "undefined") {
            window.ttq.track("Search", {
                // eslint-disable-next-line camelcase
                content_id: "Homepage search ".concat(values.type, " ").concat(values.monthlyMax, " ").concat(values.vehicleType),
                // eslint-disable-next-line camelcase
                content_type: "product",
                // eslint-disable-next-line camelcase
                content_name: "Homepage search",
                quantity: 1,
                value: null,
                price: null,
                currency: "GBP"
            });
        }
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "homepage-search",
            lease: values.type,
            "monthly-amount": values.monthlyMax,
            action: values.vehicleType,
            experimentGroup: experimentGroup
        });
        dispatch((0,reducers_search/* findADeal */.rL)({
            leaseTypes: values.type,
            monthlyPaymentMax: values.monthlyMax === 999998 ? undefined : values.monthlyMax,
            vehicleTypes: constants/* FILTER_VEHICLE_TYPES_CARS */.DC
        }));
        router.push("/car-leasing/search");
    };
    var onVanSearchSubmit = function(values) {
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "homepage-search",
            lease: constants/* FILTER_LEASE_TYPES_BUSINESS */.kG,
            "monthly-amount": values.monthlyMax,
            action: constants/* FILTER_VEHICLE_TYPES_VANS */.Bz,
            experimentGroup: experimentGroup
        });
        dispatch((0,reducers_search/* findADeal */.rL)({
            leaseTypes: constants/* FILTER_LEASE_TYPES_BUSINESS */.kG,
            monthlyPaymentMax: values.monthlyMax === 999998 ? undefined : values.monthlyMax,
            vehicleTypes: constants/* FILTER_VEHICLE_TYPES_VANS */.Bz,
            wheelbase: values.wheelbase === 0 ? null : values.wheelbase
        }));
        router.push("/van-leasing/search");
    };
    var onLinkClick = function(item) {
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "homepage-search-chip",
            label: item.label,
            experimentGroup: experimentGroup
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (search_form_module_default()).main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            initialValues: {
                type: constants/* FILTER_LEASE_TYPES_PERSONAL */.m_,
                monthlyMax: 999998,
                wheelbase: 0,
                vehicleType: initialVehicleType
            },
            enableReinitialize: true,
            onSubmit: function(values) {
                if (values.vehicleType === constants/* FILTER_VEHICLE_TYPES_CARS */.DC) {
                    onCarSearchSubmit(values);
                } else if (values.vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz) {
                    onVanSearchSubmit(values);
                }
            },
            children: function(param) {
                var handleSubmit = param.handleSubmit, values = param.values, setFieldValue = param.setFieldValue;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: (search_form_module_default()).wrapper,
                            onSubmit: handleSubmit,
                            children: [
                                !hideToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* ChipGroup */.Z, {
                                    theme: system/* Theme.dark */.Q2.dark,
                                    onChipChange: function(newType) {
                                        handleChangeVehicleType(newType);
                                        setFieldValue("vehicleType", newType);
                                    },
                                    active: [
                                        values.vehicleType
                                    ],
                                    chips: [
                                        {
                                            chipId: constants/* FILTER_VEHICLE_TYPES_CARS */.DC,
                                            label: "Car leasing"
                                        },
                                        {
                                            chipId: constants/* FILTER_VEHICLE_TYPES_VANS */.Bz,
                                            label: "Van leasing"
                                        }, 
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (search_form_module_default()).form,
                                    children: [
                                        values.vehicleType === constants/* FILTER_VEHICLE_TYPES_CARS */.DC && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.L, {
                                            className: (search_form_module_default()).field,
                                            label: "Lease type",
                                            isCompact: true,
                                            name: "type",
                                            id: "type",
                                            options: [
                                                {
                                                    label: "Personal",
                                                    value: constants/* FILTER_LEASE_TYPES_PERSONAL */.m_
                                                },
                                                {
                                                    label: "Business",
                                                    value: constants/* FILTER_LEASE_TYPES_BUSINESS */.kG
                                                }, 
                                            ]
                                        }),
                                        values.vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.L, {
                                            className: (search_form_module_default()).field,
                                            label: "Wheelbase",
                                            isCompact: true,
                                            name: "wheelbase",
                                            id: "wheelbase",
                                            options: [
                                                {
                                                    label: "Any",
                                                    value: 0
                                                },
                                                {
                                                    label: "Small",
                                                    value: 10
                                                },
                                                {
                                                    label: "Medium",
                                                    value: 11
                                                },
                                                {
                                                    label: "Big",
                                                    value: 12
                                                }, 
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (search_form_module_default()).separator
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.L, {
                                            label: "Monthly budget",
                                            isCompact: true,
                                            className: (search_form_module_default()).field,
                                            name: "monthlyMax",
                                            id: "monthlyMax",
                                            options: [
                                                {
                                                    value: 999998,
                                                    label: "Any budget"
                                                }
                                            ].concat([
                                                150,
                                                200,
                                                250,
                                                300,
                                                350,
                                                400,
                                                450,
                                                500,
                                                550,
                                                600,
                                                650,
                                                700,
                                                750,
                                                800,
                                                900,
                                                950,
                                                1000, 
                                            ].map(function(item) {
                                                return {
                                                    label: (0,search/* formatPrice */.T4)(item),
                                                    value: item
                                                };
                                            }))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery, {
                                            minWidth: 992,
                                            children: function(matches) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    icon: matches ? "Search" : "",
                                                    label: matches ? "Search deals" : "Search",
                                                    size: system/* Size.Large */.$u.Large,
                                                    hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                                                    type: "submit"
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        values.vehicleType === constants/* FILTER_VEHICLE_TYPES_CARS */.DC && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (search_form_module_default()).pills,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery, {
                                    minWidth: 992,
                                    children: function(matches) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: (search_form_module_default()).pills__title,
                                            children: [
                                                "Popular",
                                                matches && " searches",
                                                ":"
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (search_form_module_default()).pills__container,
                                    children: savedSearchReferences.map(function(item, idx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                                hierarchy: Button/* ButtonHierarchy.Borderless */.B.Borderless,
                                                theme: system/* Theme.dark */.Q2.dark,
                                                size: system/* Size.Medium */.$u.Medium,
                                                hasUnderline: true,
                                                onClick: function() {
                                                    return onLinkClick(item);
                                                },
                                                href: "/car-leasing/search/".concat(item.ref),
                                                children: item.label
                                            })
                                        }, idx);
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./components/views/SearchForm/index.ts


// EXTERNAL MODULE: ./components/views/SearchFormCTA/search-form-cta.module.scss
var search_form_cta_module = __webpack_require__(32069);
var search_form_cta_module_default = /*#__PURE__*/__webpack_require__.n(search_form_cta_module);
;// CONCATENATED MODULE: ./components/views/SearchFormCTA/SearchFormCTA.tsx




var SearchFormCTA = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (search_form_cta_module_default()).main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (search_form_cta_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (search_form_cta_module_default()).title,
                    children: "Quickly search all the big leasing sites"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {
                    initialVehicleType: constants/* FILTER_VEHICLE_TYPES_CARS */.DC
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/views/SearchFormCTA/index.ts



/***/ }),

/***/ 11783:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"breadcrumbs_main__VBByA","crumbs":"breadcrumbs_crumbs__pJ96J","crumb":"breadcrumbs_crumb__NOO8e","phAnimation":"breadcrumbs_phAnimation__MNg6t"};

/***/ }),

/***/ 37404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"group":"chip_group__fad1Q","phAnimation":"chip_phAnimation__UBr_D"};

/***/ }),

/***/ 76625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"dropdown_main__nNbQW","select":"dropdown_select__Ph18m","label":"dropdown_label__0XOh4","foot":"dropdown_foot__AKoKp","compact":"dropdown_compact__WBvLH","control":"dropdown_control__pDabX","default-selected":"dropdown_default-selected__UfhkH","icon":"dropdown_icon__mcKHW","phAnimation":"dropdown_phAnimation__X7rEA"};

/***/ }),

/***/ 87053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"search-form_main__wrDWH","wrapper":"search-form_wrapper__oDmI0","form":"search-form_form__OTIND","field":"search-form_field__Q_kX8","separator":"search-form_separator__JsWGw","pills":"search-form_pills__tN73W","pills__title":"search-form_pills__title__M5ayy","pills__container":"search-form_pills__container__QwJdL","phAnimation":"search-form_phAnimation__GEtK5"};

/***/ }),

/***/ 32069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"search-form-cta_main__BGo2t","content":"search-form-cta_content__8vx7u","title":"search-form-cta_title__0B4VG","phAnimation":"search-form-cta_phAnimation__Df6yh"};

/***/ }),

/***/ 26525:
/***/ (function(module) {

module.exports = function(md, options) {
  options = options || {};
  options.listUnicodeChar = options.hasOwnProperty('listUnicodeChar') ? options.listUnicodeChar : false;
  options.stripListLeaders = options.hasOwnProperty('stripListLeaders') ? options.stripListLeaders : true;
  options.gfm = options.hasOwnProperty('gfm') ? options.gfm : true;
  options.useImgAltText = options.hasOwnProperty('useImgAltText') ? options.useImgAltText : true;

  var output = md || '';

  // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
  output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, '');

  try {
    if (options.stripListLeaders) {
      if (options.listUnicodeChar)
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, options.listUnicodeChar + ' $1');
      else
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, '$1');
    }
    if (options.gfm) {
      output = output
        // Header
        .replace(/\n={2,}/g, '\n')
        // Fenced codeblocks
        .replace(/~{3}.*\n/g, '')
        // Strikethrough
        .replace(/~~/g, '')
        // Fenced codeblocks
        .replace(/`{3}.*\n/g, '');
    }
    output = output
      // Remove HTML tags
      .replace(/<[^>]*>/g, '')
      // Remove setext-style headers
      .replace(/^[=\-]{2,}\s*$/g, '')
      // Remove footnotes?
      .replace(/\[\^.+?\](\: .*?$)?/g, '')
      .replace(/\s{0,2}\[.*?\]: .*?$/g, '')
      // Remove images
      .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, options.useImgAltText ? '$1' : '')
      // Remove inline links
      .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, '$1')
      // Remove blockquotes
      .replace(/^\s{0,3}>\s?/g, '')
      // Remove reference-style links?
      .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, '')
      // Remove atx-style headers
      .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm, '$1$2$3')
      // Remove emphasis (repeat the line to remove double emphasis)
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      // Remove code blocks
      .replace(/(`{3,})(.*?)\1/gm, '$2')
      // Remove inline code
      .replace(/`(.+?)`/g, '$1')
      // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
      .replace(/\n{2,}/g, '\n\n');
  } catch(e) {
    console.error(e);
    return md;
  }
  return output;
};


/***/ })

}]);